import { Injectable } from '@angular/core';
import { PDFDocument } from 'pdf-lib';
 
@Injectable({
  providedIn: 'root'
})
export class PdfService {
  private readonly PDF_TEMPLATE_PATH = '../../../assets/pdf_templates/SenecaIntl_CertificateofRep_forAGENTAPP.pdf';
 
  async generateCertificate(profileData: any): Promise<Uint8Array> {
    // Load PDF template
    const pdfBytes = await this.loadPdfTemplate();
    const pdfDoc = await PDFDocument.load(pdfBytes);
    // Fill in the form fields with profile data
    const form = pdfDoc.getForm();
    const agencyNameField = form.getTextField('Agency name');
    agencyNameField.setText(profileData.companyName);
    agencyNameField.setFontSize(23); // Adjust font size (12 is default)
    const dateField = form.getTextField('Valid until date MM/DD/YYYY');
    dateField.setText(this.formatDate(profileData.certificationExpirationDate));
    dateField.setFontSize(14);
    // Make PDF non-editable by flattening the form
    form.flatten();
    return await pdfDoc.save();
  }
 
  private async loadPdfTemplate(): Promise<ArrayBuffer> {
    const response = await fetch(this.PDF_TEMPLATE_PATH);
    return await response.arrayBuffer();
  }
 
  private formatDate(dateString: string): string {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });
  }
}